import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { jsonToGraphQLQuery } from "json-to-graphql-query";
import "./assets/styles/index.css";
import { APIPREFIX } from "@/api.js";
import VueTailwindModal from "vue-tailwind-modal";
import VueCircleSlider from "vue-circle-slider";
import vSelect from "vue-select";
import Vue2Editor, { Quill } from "vue2-editor";
import VueSocialSharing from 'vue-social-sharing';
import VTooltip from 'v-tooltip'
import VueObserveVisibility from 'vue-observe-visibility'


const sizeStyle = Quill.import('attributors/style/size')
sizeStyle.whitelist = ['10px', '12px', '14px', '16px', '18px', '20px', '24px', '30px', '32px', '36px']
Quill.register(sizeStyle, true)

import { Auth0Plugin } from "./auth";
import auth0Config from "../auth_config";
console.log('auth0Config: ', auth0Config);

// USE ALL THE STUFF!
Vue.use(Auth0Plugin, {
  ...auth0Config,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});
Vue.use(VueCircleSlider);
Vue.component("VueTailwindModal", VueTailwindModal);
Vue.component("v-select", vSelect);
Vue.use(VTooltip);
Vue.use(Vue2Editor);
Vue.use(VueSocialSharing);
Vue.use(VueObserveVisibility)


// INSTALL MARKDOWN/KATEX processor
var md = require("markdown-it")();
var mk = require("markdown-it-texmath");
md.use(mk);

window.$samsa = new Samsa(APIPREFIX + "/");
window.$router = Vue.$router;
Vue.prototype.$samsa = $samsa;
Vue.prototype.$markdown = md

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
